import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { getPublicAsset } from 'base/shared/Utils';
import { translate } from 'base/shared/Localization';

const Section = styled.section`
  width: 100%;
  padding: 64px 0 32px 0;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
`;

const Title = styled.h2`
  text-align: left;
  font-size: 2rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 64px;
`;

const StepsGrid = styled.div`
  display: flex;
  justify-content: center;
  gap: 48px;
  flex-wrap: wrap;
`;

const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 340px;
  max-width: 100%;
`;

const StepSubtitle = styled.div`
  font-size: 1.15rem;
  color: #222;
  text-align: center;
  margin-bottom: 8px;
  font-weight: 500;
  min-height: 48px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  max-width: 200px;
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 642px;
  background-image: ${({ image }) => `url(${getPublicAsset(`v2/images/${image}`)})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 32px;
  margin-bottom: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

function HowBadiWorks({ locale }) {
  const imageSuffix = locale === 'es' ? '-es' : '';

  return (
    <Section>
      <Content>
        <Title>{translate('v2.home.howBadiWorks.title')}</Title>
        <StepsGrid>
          <Step>
            <StepSubtitle>{translate('v2.home.howBadiWorks.step1')}</StepSubtitle>
            <ImageWrapper image={`how-badi-works-1${imageSuffix}.png`} />
          </Step>
          <Step>
            <StepSubtitle>{translate('v2.home.howBadiWorks.step2')}</StepSubtitle>
            <ImageWrapper image={`how-badi-works-2${imageSuffix}.png`} />
          </Step>
          <Step>
            <StepSubtitle>{translate('v2.home.howBadiWorks.step3')}</StepSubtitle>
            <ImageWrapper image={`how-badi-works-3${imageSuffix}.png`} />
          </Step>
        </StepsGrid>
      </Content>
    </Section>
  );
}

const mapStateToProps = (state) => ({
  locale: state.Localization.locale,
});

export default connect(mapStateToProps)(HowBadiWorks);
